import {createContext, ReactNode, useContext} from "react";
import {useNavigate} from "react-router-dom";
import {updateApisWithBasicAuth} from "../api/api";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../store";
import {loggedIn, loggedOut} from "../store/reducers/authenticated";

const BasicAuthContext = createContext({
  login: (user: string, password: string) => {
  },
  logout: () => {
  }
});

export const BasicAuthProvider = (props: { children: ReactNode }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const login = (user: string, password: string) => {
    localStorage.setItem("user", user);
    localStorage.setItem("password", password);
    localStorage.setItem("isAuthenticated", "true");
    updateApisWithBasicAuth();
    dispatch(loggedIn());
  }

  const logout = () => {
    localStorage.clear();
    updateApisWithBasicAuth();
    navigate("/");
    dispatch(loggedOut());
  }

  return <BasicAuthContext.Provider
      value={{login, logout}}>
    {props.children}
  </BasicAuthContext.Provider>
}

export const useBasicAuth = () => useContext(BasicAuthContext)